module.exports = __webpack_public_path__ + "static/media/DSC_0689.6605cdd3.jpg";